export const NEFTRTGSDetailsPopUp = ({ cancelbtn, heading }) => {
    return (
        <>
            {/* <div className="row">
                <di className="col-12"> */}
            <div className="modal fade show"
                style={{
                    display: "flex", alignItems: 'center', backgroundColor: "#00000090",
                    zIndex: 99999, position: 'fixed', top: 0, left: 0, right: 0, bottom: 0
                }}>
                <div className="modal-dialog" role="document"
                    style={{
                        minWidth: '70%', height: '85vh', maxHeight: '85vh'
                    }}
                >
                    <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div className="modal-header">
                            <h5 className="card-title fw-bold green pt-1" style={{ paddingLeft: '10px' }} id="exampleModalLongTitle">{heading}</h5>
                            <button onClick={() => cancelbtn()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body examination mx-0" style={{ overflowY: 'auto', flex: 1 }}>
                            <div className="row">
                                <div className="row p-2 m-0 poppins-regular" >

                                    <div class=" col-12 ">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Permanent Account No</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label  ">AIHPD0347A</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class=" col-12 ">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">GST NO</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">27AIHPD0347A1ZY</label>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="mt-2" style={{ color: 'lightgray' }} />

                                    <div class="my-2 col-12">
                                        <label for="exampleFormControlInput1" class="form-label fw-bold">For RTGS/IFSC (NEFT ENABLED)/SWIFT PAYMENTS</label>
                                    </div>

                                    <div class=" col-12">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Bank Name</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">Axis Bank Limited</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class=" col-12">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Bank Branch</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">GMS Road, Dehradun</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class=" col-12">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Bank Address</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">GMS Road, Dehradun (UT), Dehradun-248001</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class=" col-12 ">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Account Name</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">ANURADHA PRASAD MORE</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class=" col-12 ">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">Saving Account No</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">922020014643663</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 ">
                                        <div className="row">
                                            <div className="col-5">
                                                <label for="exampleFormControlInput1" class="form-label ">IFSC Code</label>
                                            </div>
                                            <div className="col-1">:</div>
                                            <div className="col-6">
                                                <label for="exampleFormControlInput1" class="form-label ">UTIB0001270</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr className="mt-2" style={{ color: 'gray' }} />
                                <div className="row text-center">
                                    <div className="col-12">
                                        {/* <button
                                            type='button'
                                            onClick={cancelbtn}
                                            className="w-80 btn addbtn btn-success  m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-floppy-disk pe-1"></i> Submit
                                        </button> */}
                                        <button
                                            type="button"
                                            onClick={cancelbtn}
                                            className="w-80  btn addbtn btn-danger  m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-xmark pe-1"></i> Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </di>
            </div> */}
        </>
    )
}